import * as  OrderActions from './orders.actions';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import { Order } from '@kion/data-models';

export const ORDERS_FEATURE_KEY = 'order';

export interface OrdersState extends EntityState<Order> {
  error?: any;
  lastCreatedId: string|null;

  isSearching: boolean;
  searchResultIds: string[];

  pagination: {
    page: number,
    perPage: number,
    totalPages: number,
    count: number,
    total: number
  }
  query: string,
  totalResult: number
}

export const adapter: EntityAdapter<Order> = createEntityAdapter<Order>();

export interface OrdersPartialState {
  readonly [ORDERS_FEATURE_KEY]: OrdersState;
}

export const initialState: OrdersState = adapter.getInitialState({
  lastCreatedId: null,
  isSearching: false,
  searchResultIds: [],
  searchQuery: {},
  pagination: {
    page: 1,
    perPage: 20,
    totalPages: 0,
    count: 0,
    total: 0
  },
  query: null,
  totalResult: 0
});

const OrdersReducer = createReducer(
  initialState,
  on(
    OrderActions.loadAllSuccess,
    (state, { orders  }) => adapter.upsertMany(orders , { ...state })
  ),
  on(
    OrderActions.loadByIdSuccess,
    (state, { order  }) => adapter.upsertOne(order , { ...state })
  ),
  on(
      OrderActions.loadOrderHistoryByIdSuccess,
      (state, { order  }) => adapter.upsertOne(order , { ...state })
   ),
  on(
     OrderActions.searchSuccess,
      (state, {searchResult}) => {
         return adapter.upsertMany(
            searchResult.orders,
            {
               ...state,
               isSearching: false,
               searchResultIds: searchResult.orders.map(
                  (order: Order) => order.id
               ),
               pagination: {
                  page: searchResult.pagination.page + 1,
                  perPage: searchResult.pagination.count,
                  totalPages: searchResult.pagination.totalPages,
                  total: searchResult.pagination.totalCount
               },
               totalResult: !searchResult.query ? searchResult.pagination.totalCount : state.totalResult
            }
         ) as OrdersState
      }
   ),
   on (
      OrderActions.updatePerPageSuccess,
      OrderActions.updatePageSuccess,
      (state, { pagination  }) => {
         return {...state, pagination: pagination}
      }
   ),
   on(
      OrderActions.updateQuerySuccess,
      (state, { query}) => {
         return { ...state, query: query }
      }
   )
);

export function reducer(
  state: OrdersState | undefined,
  action: Action
) {
  return OrdersReducer(state, action);
}
